<template>
  <div class="timeline">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="timeline__node"
      :class="{ 'timeline__node--current': isLastNode(index) && currentLabel }"
    >
      <span class="timeline__dot" />
      <div class="timeline__date">
        {{ item.datetime }}
      </div>
      <div class="timeline__transfer">
        <BaseStatusPill
          :label="item.type"
          :variant="item.variant || 'neutral'"
        />
        <span class="timeline__arrow">→</span>
        <BaseEntityBadge
          :initials="item.entity.initials"
          :name="item.entity.name"
        />
        <BaseStatusPill
          v-if="isLastNode(index) && currentLabel"
          class="timeline__current-pill"
          :label="currentLabel"
          variant="success"
        />
      </div>
      <div
        v-if="item.docRef"
        class="timeline__doc"
      >
        {{ item.docRef }}
      </div>
    </div>
  </div>
</template>

<script>
import BaseStatusPill from './BaseStatusPill.vue'
import BaseEntityBadge from './BaseEntityBadge.vue'

export default {
  name: 'BaseTimeline',
  components: { BaseStatusPill, BaseEntityBadge },
  props: {
    items: {
      type: Array,
      required: true
    },
    currentLabel: {
      type: String,
      required: false,
      default: null
    }
  },
  methods: {
    isLastNode(index) {
      return index === this.items.length - 1
    }
  }
}
</script>

<style lang="scss">
.timeline {
  position: relative;
  padding-left: 22px;

  &::before {
    content: '';
    position: absolute;
    left: 6px;
    top: 4px;
    bottom: 4px;
    width: 2px;
    background: var(--ds-color-black-010);
  }

  &__node {
    position: relative;
    padding-bottom: 20px;
    font-size: 0.8rem;

    &:last-child {
      padding-bottom: 0;
    }
  }

  &__dot {
    position: absolute;
    left: -22px;
    top: 2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--ds-color-black-040);
    border: 2px solid var(--ds-color-white);
    box-shadow: 0 0 0 1px var(--ds-color-black-010);
  }

  &__node--current &__dot {
    background: var(--v-primary-base);
    box-shadow: 0 0 0 3px rgba(64, 117, 109, 0.14);
  }

  &__date {
    font-size: 0.75rem;
    color: var(--ds-color-black-040);
    margin-bottom: 6px;
  }

  &__transfer {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    flex-wrap: wrap;
  }

  &__current-pill {
    margin-left: auto;
  }

  &__arrow {
    color: var(--ds-color-black-040);
    font-size: 13px;
  }

  &__doc {
    font-size: 0.75rem;
    color: var(--ds-color-anchor);
  }
}
</style>
